import { axios } from './config';

// 部门列表
export function deptList(params) {
    return axios.post('/businessManagement/departmentManagement/list_all', params, false)
}
